/**
 * @desc 分页
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.LogisticsGroupAttrResponseDto>
>;
export function request(
  params: API.basics.logisticsGroupAttr.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/logisticsGroupAttr/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
